import type { AircraftType } from './types.ts';

// Tuned in the v10 prototype; speeds are logical px/s where the logical
// viewport has min(W,H)=390 (an iPhone). Keep ids stable: levels refer to them.
//
// `points` is what one arrival of that type is worth before the level's own
// multiplier (see `landingPoints`). It is a reading of how much of the
// player's attention the type costs, not of its size: a light is quick and
// turns inside its own length; a helicopter is nimbler still but only the pad
// will do; a medium is the baseline airliner; a heavy is slow enough to sit in
// the sky the longest and turns in a ~50px circle; a jet turns in the same
// circle at nearly three times the speed, which is the least reaction time in
// the fleet. So: nimble and forgiving is cheap, slow or fast is dear.
export const AIRCRAFT: Record<string, AircraftType> = {
  light:  { id: 'light',  label: 'light',  color: '#f5a623', speed: 36, scale: 0.82, turn: 0.90, look: 30, kind: 'plane', points: 5 },
  medium: { id: 'medium', label: 'medium', color: '#2d9cdb', speed: 26, scale: 1.0,  turn: 0.58, look: 34, kind: 'plane', points: 10 },
  heavy:  { id: 'heavy',  label: 'heavy',  color: '#de4b39', speed: 18, scale: 1.28, turn: 0.36, look: 40, kind: 'plane', points: 15 },
  jet:    { id: 'jet',    label: 'jet',    color: '#8e6bbf', speed: 48, scale: 0.92, turn: 0.95, look: 38, kind: 'plane', points: 20 },
  heli:   { id: 'heli',   label: 'heli',   color: '#1fa896', speed: 21, scale: 0.85, turn: 2.60, look: 20, kind: 'heli',  points: 8 },
};

export function aircraftType(id: string): AircraftType {
  const t = AIRCRAFT[id];
  if (!t) throw new Error(`unknown aircraft type: ${id}`);
  return t;
}

/** minimum turning radius at a given speed */
export function turnRadius(t: AircraftType, speed = t.speed): number { return speed / t.turn; }
